import { initializeApp, getApps, getApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyAagNJGOKbOXhqDJ6cv0E9mCHUJv0AjQA8",
  authDomain: "suite-gestion-hoprinplus.firebaseapp.com",
  projectId: "suite-gestion-hoprinplus",
  storageBucket: "suite-gestion-hoprinplus.firebasestorage.app",
  messagingSenderId: "231639303719",
  appId: "1:231639303719:web:670916b422b1f7eeef3002"
};

const app = getApps().length > 0 ? getApp() : initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);

